export default "assets/images/logos_mastercard-61de29af.png";